import "./styles/navFooter.scss";
import { useNavigate } from "react-router-dom";

export default function Header(props) {
  const navigate = useNavigate();

  const calculateTimeLeft = () => {
    let event = new Date(props.timeLeft).getTime();
    let now = new Date().getTime();

    let distance = event - now;

    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return `${days}day, ${hours}h, ${minutes}min, ${seconds}secs`;
  };

  // return <nav></nav>;
}
